import { PlainModal } from '@/components/modals/plain-modal';
import { TextLink } from '@/components/text-link';
import { joinSgcmSite } from '@/utils/url/join/public';

import { MODAL_TITLE } from './constants';
import styles from './styles.module.scss';
import type { Component } from './types';

export const OmvModal: Component = ({
  isOpen,
  onClose,
}) => (
  <PlainModal
    className={styles.containerOmvModal}
    isOpen={isOpen}
    modalTitle={MODAL_TITLE}
    onClose={onClose}>
    <div>
      The listed OMV value is that of the first registration date
      of the vehicle.
    </div>
    <div>
      OMV stands for Open Market Value. OMV is assessed by the Singapore
      Customs, based on the price actually paid or payable for the goods
      when sold for export to the country of importation. This price includes
      purchase price, freight, insurance and all other charges incidental
      to the sale and delivery of the car to Singapore.
    </div>
    <div>
      If the vehicle is de-registered within 10 years from its first
      registration date, the registered owner is entitled to a percentage
      rebate of its OMV value from the Land Transport Authority (LTA).
      Read more about the
      <TextLink
        className={styles.textLink}
        href={`${joinSgcmSite('/articles/advice/understanding-omv-parf-and-coe-rebates-for-your-car-30522')}`}
        target="_blank"
        text="  LTA PARF rebate scheme" />
      .
    </div>
    <div>
      You may use the OMV rebate to exchange for cash at LTA.
      Do note that processing time is typically a few weeks.
    </div>
    <br />
  </PlainModal>
);
